package com.milta.core.localization.translations.en

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Route",
    navEcoDriving = "Eco Driving",
    navCommunity = "Community",
    navRewards = "Rewards",
    navHome = "Home",
    navRoutes = "Routes",
    navTeam = "Team",
    navProfile = "Profile",
    navDashboard = "Dashboard",
)
